import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import i18n from 'utils/I18n';
import queryString from 'query-string';

import { ACTION_BUTTON_STATUS } from 'component/campaign/CheckInSection';
import ImageSlider from 'component/campaign/ImageSlider';
import SharedSection, { BlockedSharedSection } from 'component/campaign/SharedSection';
import ShortDescription from 'component/campaign/ShortDescription';
import CampaignCard from 'component/common/CampaignCard';
import OfferFloatActionButton from 'component/offer/OfferFloatActionButton';
import BreadCrumbs from 'component/common/BreadCrumbs';
import { createAction, detectIsMobile } from 'utils';
import { APP_NAME, WEB_DOMAIN } from 'utils/Config';
import { detectIsMobileByScreenWidth } from 'utils/ScreenUtils';
import { getShareStoreUrl } from 'utils/CampaignUtil';
import './StoreDetail.scss';
import { inMiniProgram, openMiniProgramMap } from 'utils/WeChatUtil';

@connect(({ users, store }) => ({
  language: users.language,
  membershipID: users.userInfo.memberShipID,
  isLogin: users.isLogin,
  storeDetailDict: store.store,
  storeDistricts: store.storeDistricts,
}))
class StoreDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // showScanQRCodeModal: false,
      qrCodeString: '',
      showScanner: false,
      storeDetail: {},
      storeDistrict: '',
      phoneNumber: '-',
      email: '-',
    };
  }

  componentDidMount() {
    this.storeID = this.props.match.params?.id;
    this.props.dispatch(
      createAction('store/getOneStore')({
        id: this.storeID,
      }),
    );
    this.props.dispatch(createAction('store/getStoreRegions')());
  }

  componentDidUpdate(prevProps) {
    if (this.props.language !== prevProps.language) {
      this.props.dispatch(
        createAction('store/getOneStore')({
          id: this.storeID,
        }),
      );
    }
    if (this.props.storeDetailDict !== prevProps.storeDetailDict) {
      const storeDetail = this.props.storeDetailDict[this.storeID];
      console.log('storeDetail', storeDetail);
      let phoneNumber = '-';
      if (
        !!storeDetail?.phoneNumberCountryCode &&
        !!storeDetail?.subscriberNumber
      ) {
        phoneNumber = `+${storeDetail?.phoneNumberCountryCode} ${storeDetail?.subscriberNumber}`;
      }
      let email = '-';
      if (!!storeDetail?.emailAddress) {
        email = storeDetail?.emailAddress;
      }
      this.setState({
        storeDetail: storeDetail,
        phoneNumber,
        email,
      });
    }
    if (
      this.props.storeDetailDict !== prevProps.storeDetailDict ||
      this.props.storeDistricts !== prevProps.storeDistricts
    ) {
      const storeDetail = this.props.storeDetailDict[this.storeID];
      const storeDistricts = this.props.storeDistricts;

      const districtID = storeDetail?.district;
      if (storeDistricts?.length > 0) {
        for (const x of storeDistricts) {
          for (const district of x.district) {
            if (district.id === districtID) {
              const districtName = district.name;
              this.setState({
                storeDistrict: districtName,
              });
              return;
            }
          }
        }
      }

      this.setState({
        storeDistrict: '',
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(
      createAction('campaignDetail/updateState')({
        actionButtonStatus: ACTION_BUTTON_STATUS.NORMAL,
      }),
    );
  }

  clickSubCategoryTab(subItem) {
    const newUrl = `/store?sf_category=${subItem.categoryId}&sf_sub_category[0]=${subItem.id}`;
    this.props.history.push(newUrl);
  }

  showImageSlider = () => {
    if (this.state.storeDetail?.photoUrl) {
      return <ImageSlider images={[this.state.storeDetail?.photoUrl]} />;
    } else {
      return <ImageSlider images={[]} />;
    }
  };

  subCategoryTags = () => {
    if (this.state.storeDetail?.subcategories?.length > 0) {
      let subcategories = this.state.storeDetail.subcategories;
      //      subcategories = subcategories
      //      .concat(subcategories).concat(subcategories).concat(subcategories)
      //      .concat(subcategories).concat(subcategories).concat(subcategories)
      //      .concat(subcategories).concat(subcategories).concat(subcategories)
      //      .concat(subcategories).concat(subcategories).concat(subcategories);
      const tags = subcategories?.map((subcategory, index) => {
        return (
          <span
            className={detectIsMobileByScreenWidth() ? "tag-menu-1" : "field-text"}
            key={subcategory.id}
            onClick={() => this.clickSubCategoryTab(subcategory)}
          >
            {subcategory.name}
          </span>
        );
      });
      return tags;
    }
    return <></>;
  };

  showDescription = () => {
    if (!!this.state.storeDetail?.description) {
      return (
        <>
          <Row>
            <div className={`store_detail_title ${detectIsMobileByScreenWidth() ? "subheading" : "title-small"}`}>
              {i18n.t('store:store_description')}
            </div>
          </Row>
          <Row>
            <ShortDescription
              description={this.state.storeDetail?.description}
            />
          </Row>
        </>
      );
    }
    return <></>;
  };

  showCampaignList = () => {
    if (this.state.storeDetail?.campaigns?.length > 0) {
      return (
        <div className="campaign_list">
          <div className={`campaign_list_title ${detectIsMobileByScreenWidth() ? "subheading" : "headline"}`}>
            {i18n.t('store:related_campaign')}
          </div>
          <div className="campaign_list_scroll_view">
            {this.state.storeDetail?.campaigns?.map((data, index) => (
              <CampaignCard
                cardData={data}
                key={index}
                shouldShowCampaignTag={true}
                inStoreDetail
              />
            ))}
          </div>
        </div>
      );
    }
    return <></>;
  };

  render() {
    const coverImage = this.state.storeDetail?.photoUrl;
    const sharePath = `/storeDetail/${this.storeID}`
    const storeName = this.state.storeDetail?.name;
    const shareTitle = `${APP_NAME} - ${storeName}`;
    const url = getShareStoreUrl(this.storeID);
    const message = `東瀛遊 - ${storeName}. ${i18n.t(
      'campaignDetail:checkItNow',
    )} \n ${url} `;
    const breadList = [{ path: "/", name: "home_home" }, { path: "/store", name: "profile_store_directory" }, { path: "", name: "store:store_detail" },]
    return (
      <div className="user_container_background">
        <Container className="store_detail_container">
          <BreadCrumbs breadList={breadList}/>
          <Row>
            <Col className="d-md-block left_section">
              <Row>{this.showImageSlider()}</Row>
              <Row>
                <div className={`offer_title ${detectIsMobileByScreenWidth() ? "headline" : "title-large"}`}>
                  {this.state.storeDetail?.name}
                </div>
              </Row>
              <Row>
                <div className={`sub_title ${detectIsMobileByScreenWidth() ? "tag-menu-2" : "headline"}`}>
                  {this.state.storeDetail?.brandName}
                </div>
              </Row>
              <Row>
                <div className="store_sub_category">
                  {this.subCategoryTags()}
                </div>
              </Row>
              <div className="custom_separate sub_dividing" />
              {!!this.state.storeDistrict ? (
                <Row>
                  <div className={`location ${detectIsMobileByScreenWidth() ? "body-3" : "headline"}`}>{this.state.storeDistrict}</div>
                </Row>
              ) : (
                <></>
              )}
              <Row>
                <div
                  className={'store_location body-1'}
                  onClick={() => {
                    const latitude = this.state.storeDetail?.latitude; // -90, 90
                    const longitude = this.state.storeDetail?.longitude; // -180, 180
                    if (latitude == null || longitude == null) {
                      return
                    }
                    if (inMiniProgram()) {
                      openMiniProgramMap({ latitude, longitude })
                      return
                    }
                    const search = queryString.stringify(
                        {
                          api: '1',
                          query: `${latitude},${longitude}`,
                        },
                        {
                          encode: true,
                        },
                      );
                    const googleMapUrl =
                      'https://www.google.com/maps/search/?' + search;
                    window.open(googleMapUrl);
                  }}
                >
                  <Image
                    className={'g3_color_image'}
                    src="/action/location.png"
                    srcSet="/action/location@2x.png 2x, /action/location@3x.png 3x"
                  />
                  <span className="location_name">
                    {this.state.storeDetail?.address}
                  </span>
                </div>
              </Row>
              {
                this.state.phoneNumber !== '-' || this.state.email !== '-'
                  ? <Row>
                    <div className="contact">
                      <div
                        className="contact-phone"
                        onClick={() => {
                          if (
                            detectIsMobile() &&
                            this.state.phoneNumber !== '-'
                          ) {
                            window.open(`tel:${this.state.phoneNumber}`);
                          }
                        }}
                      >
                        <Image
                          className={'g3_color_image'}
                          src="/action/phone.png"
                          srcSet="/action/phone@2x.png 2x, /action/phone@3x.png 3x"
                        />
                        <div className="contact-phone-text">
                          <label className='body-3'>{i18n.t('store:phone')}</label>
                          <span className='body-1'>{this.state.phoneNumber}</span>
                        </div>
                      </div>
                      <div className="custom_separate" />
                      <div
                        className="contact-email"
                        onClick={() => {
                          window.open(
                            `mailto:${this.state.email}?subject=&body=`,
                          );
                        }}
                      >
                        <Image
                          className={'g3_color_image'}
                          src="/action/inbox.png"
                          srcSet="/action/inbox@2x.png 2x, /action/inbox@3x.png 3x"
                        />
                        <div className="contact-email-text">
                          <label className='body-3'>{i18n.t('settings_email')}</label>
                          <span className='body-1'>{this.state.email}</span>
                        </div>
                      </div>
                    </div>
                  </Row>
                  : <div className='contact-empty'/>
              }
              <Row className="dividing" />
              {this.showDescription()}
              {detectIsMobileByScreenWidth() ? (
                <>
                  <Row className="mobile_related_campaign">
                    {this.showCampaignList()}
                  </Row>
                  <BlockedSharedSection title={shareTitle} message={message} pathname={sharePath} weChatShareTitle={storeName} weChatShareImgUrl={coverImage} />
                </>
              ) : (
                <></>
              )}
            </Col>

            <Col className=" col-md-4 right_section">
              <div className="float_right_section">
                {this.showCampaignList()}
                <SharedSection title={shareTitle} message={message} pathname={sharePath} weChatShareTitle={storeName} weChatShareImgUrl={coverImage} />
              </div>
            </Col>
          </Row>
          <OfferFloatActionButton />
        </Container>
      </div>
    );
  }
}

export default withRouter(StoreDetail);
